/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

const ErrorViewPropTypes = {
  error: PropTypes.bool.isRequired, // If there is an error
  errorMsg: PropTypes.string.isRequired, // The message to display to the user
  handleClick: PropTypes.func.isRequired, // Method to invoke when 'x' is clicked
};

const ErrorViewDefaultProps = {};

// eslint-disable-next-line arrow-parens
const ErrorView = props => {
  const { error, errorMsg, handleClick } = props;

  if (error) {
    return (
      <div className="particles-alert particles-alert--info">
        <div>{errorMsg}</div>
        <i
          className="alert-link"
          data-trigger="close"
          onClick={e => handleClick(e)}
          role="button"
          tabIndex="0"
        >
          &#215;
        </i>
      </div>
    );
  }

  return null;
};

ErrorView.propTypes = ErrorViewPropTypes;

ErrorView.defaultProps = ErrorViewDefaultProps;

export default ErrorView;
